module.exports = __webpack_public_path__ + "static/media/undraw_feedback_h2ft.794efdfc.svg";